import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
} from "react";
import { DndSortChangeEvent } from "../types";

export type PreviewRendererParams = {
  valid: boolean; // Indicates if the item being dragged is valid for the current drop target
};

export type PreviewRenderer = (params: PreviewRendererParams) => ReactNode;

export type DndSortContextValue = {
  previewRenderer: PreviewRenderer; // Function to render the preview of the item being dragged
  setPreviewRenderer: Dispatch<SetStateAction<PreviewRenderer>>; // Function to set the preview node
  onDrop: (event: DndSortChangeEvent) => void; // Optional callback function when an item is dropped
};

export const DEFAULT_CONTEXT_VALUE: DndSortContextValue = {
  previewRenderer: () => null,
  setPreviewRenderer: () => () => null,
  onDrop: () => {
    return;
  },
};

export const DndSortContext = createContext(DEFAULT_CONTEXT_VALUE);

export const useDndSortContext = () => {
  return useContext(DndSortContext);
};
